/**
 * Return-to support for the Google OAuth login flow. The requested path is
 * stashed in sessionStorage before redirecting to Google (the OAuth round-trip
 * loses in-app state) and consumed by the callback page after sign-in.
 */

export const POST_LOGIN_REDIRECT_KEY = 'post_login_redirect';

/** Only same-app absolute paths are allowed — no external/protocol-relative URLs. */
export function isSafeInternalPath(path: string | null | undefined): path is string {
  return !!path && path.startsWith('/') && !path.startsWith('//');
}

/** Pop the stashed return-to path, falling back to the app root. */
export function consumePostLoginRedirect(): string {
  const next = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  return isSafeInternalPath(next) ? next : '/';
}
